var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 13.8936L13 35.8936M17 21.8936V13.8936M13 17.8936H21M27 31.8936H35M15.6 42.8936H32.4C35.7603 42.8936 37.4405 42.8936 38.7239 42.2396C39.8529 41.6644 40.7708 40.7465 41.346 39.6175C42 38.334 42 36.6539 42 33.2936V16.4936C42 13.1332 42 11.4531 41.346 10.1696C40.7708 9.04064 39.8529 8.12276 38.7239 7.54752C37.4405 6.89355 35.7603 6.89355 32.4 6.89355H15.6C12.2397 6.89355 10.5595 6.89355 9.27606 7.54752C8.14708 8.12276 7.2292 9.04064 6.65396 10.1696C6 11.4531 6 13.1332 6 16.4936V33.2936C6 36.6539 6 38.334 6.65396 39.6175C7.2292 40.7465 8.14708 41.6644 9.27606 42.2396C10.5595 42.8936 12.2397 42.8936 15.6 42.8936Z",
    stroke: "#0F0F0F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.2f2d6d7f4af0dbc25860cf722f1568ff.svg";
export { ForwardRef as ReactComponent };